import { createContext } from 'react';

const EmploymentContext = createContext();

export default EmploymentContext;
